/**
 * Real-time multiplayer asteroids game with TypeScript/Bun server and HTML5 Canvas client
 * Lobby domain - Lobby card container with AnimatePresence orchestration
 */

import type { LobbyMetadata } from "@game/domain";
import { AnimatePresence } from "framer-motion";
import type React from "react";
import { EmptyState } from "./EmptyState";
import { useLobbyActions } from "./hooks/useLobbyActions";
import { LobbyCard } from "./LobbyCard";

interface LobbyCardContainerProps {
  lobbies: LobbyMetadata[];
}

export const LobbyCardContainer: React.FC<LobbyCardContainerProps> = ({
  lobbies,
}) => {
  const { joinLobby } = useLobbyActions();

  if (lobbies.length === 0) {
    return <EmptyState />;
  }

  return (
    <div
      className="lobby-cards-container"
      style={{ display: "flex", flexDirection: "row", gap: "12px" }}
    >
      <AnimatePresence mode="popLayout">
        {lobbies.map((lobby, index) => (
          <LobbyCard
            key={lobby.id}
            lobby={lobby}
            isFirst={index === 0}
            onJoin={joinLobby}
            lobbiesList={lobbies}
          />
        ))}
      </AnimatePresence>
    </div>
  );
};
